import React from 'react';
import { useTranslation } from 'react-i18next';

const TopicCard = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className='topic-card-wrapper'>
      <div className='card-name' title={data?.title}>
        {data?.title?.length > 20
          ? `${data?.title?.slice(0, 20)}...`
          : data?.title}
      </div>
      <div className='card-number'>{data.flashcardCount} {t('COMMON.FLASH_CARDS')}</div>
    </div>
  );
};

export default TopicCard;
